import React, { useState } from 'react';
import "./Navbar.css";

//TODO: Have navbar accept object specifying menu items
function Navbar({
  showBuyButton = true,
  menuLocation = "end",
  displayLogo = true,
  logoText = null,
  contentViewportConstraint = null
}) {
  const [isActive, setIsActive] = useState(false);
  const containerConstraint = contentViewportConstraint != null ? "is-"+contentViewportConstraint : "";
  return (



    <nav id="topbar" className={`navbar ${isActive ? 'has-opaque-background' : ''}`} role="navigation" aria-label="main navigation">
      <div className={`container ${containerConstraint}`}>
        <div className="navbar-brand is-align-items-center">


          {displayLogo && !logoText && <a className="navbar-item" href="https://canuckz-nft.io/">
            <img id="topbar-logo" src="/Canuckz_Logo_4.png" height="32" alt="Topbar logo." />
          </a>}

          {displayLogo && logoText && <a className="navbar-item" href="/">
            <span id="topbar-logo-text">{logoText}</span>
          </a>}


          <button
            href=""
            className={`navbar-burger navbar ${isActive && 'is-active'}`}
            onClick={() => setIsActive(a => !a)}
            aria-label="menu"
            aria-expanded="false">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
        </div>

        <div className={`navbar-menu has-text-centered ${isActive ? 'is-active' : ''}`}>
          <div className={`navbar-${menuLocation}`}>
            <a href="https://canuckz-nft.io/#roadmap" className="navbar-item">
              <span className="navbar-item-text">Roadmap</span>
            </a>

            <a className="navbar-item" href="https://canuckz-nft.io/#welcome">
              <span className="navbar-item-text">About</span>
            </a>

            <a href="https://charli3.canuckz-nft.io/" className="navbar-item is-active">
              <span className="navbar-item-text">Charli3</span>
            </a>

            <a href="https://canuckz-nft.io/gallery/" className="navbar-item">
              <span className="navbar-item-text">Gallery</span>
            </a>

            {showBuyButton && <div id="buy-button-container" className="navbar-item is-flex is-justify-content-center">
              <a href="/" id="buy-button" className="button is-primary navbar-item">Buy</a>
            </div>}

            <div id="navbar-social">
              {/* <a href="/" className="navbar-item">
                <i className="fab fa-instagram"></i>
              </a> */}
              <a href="https://twitter.com/CanuckzNFT" className="navbar-item">
                <i className="fab fa-twitter"></i>

              </a>
              <a href="https://discord.com/invite/e8M5GHpycZ" className="navbar-item">
                <i className="fab fa-discord"></i>
              </a>

            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;